<template>
<div>
    <div class="box">
        <div class="box-inner">
            <div class="box-title">
                <h2>{{$t('recreation_shoppingcart_title')}}</h2>
            </div>
            <!-- /.box-title -->
            <div class="box">
                <div class="box-inner row">
                    <div class="form-group col-md-6">
                        <label for="validFrom">{{ $t('product_valid_from_label') }}</label>
                        <datepicker id="validFrom"
                                    v-model="model.validFrom"
                                    :monday-first="true"
                                    :language="importedLanguages[language]"
                                    :bootstrap-styling="true"
                                    v-validate="'required'"
                                    :data-vv-as="$t('product_valid_from_label')"
                                    @input="dateChanged"
                                    aria-required="true"
                        ></datepicker>
                        <small class="form-text text-danger" v-if="errors.has('validFrom')">
                            {{ errors.first('validFrom') }}
                        </small>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="email">{{ $t('account_email') }}</label>
                        <input name="email" id="email" type="email"
                               v-validate="'required|email'"
                               :data-vv-as="$t('account_email')"
                               class="form-control" :class="{'form-control-danger': errors.has('email')}"
                               aria-required="true" v-model="model.email">
                        <small class="form-text text-danger" v-if="errors.has('email')">
                            {{ errors.first('email') }}
                        </small>
                    </div>
                </div>
            </div>
            <div class="extras">
                <div v-for="(product) in model.productinfo" :key="product.id" class="extras-item">
                    <div class="row">
                        <div class="col-xs-12 col-sm-2 col-md-2">
                            <div v-if="product.image">
                                <img v-bind:src="'data:image/jpeg;base64,'+ product.image" />
                            </div>
                            <div v-else class="extra-icon">
                                <i class="fa fa-ticket-alt"></i>
                            </div>
                        </div>
                        <!-- /.col -->
                        <div class="col-xs-12 col-sm-6 col-md-6">
                            <div class="title">{{product.description}}</div>
                            <div class="description">
                                <p>{{$t('product_category_evoucher')}} </p>
                            </div>
                            <div class="price">€{{product.price}}</div>
                        </div>
                        <!-- /.col -->
                        <div class="col-xs-push-4 col-xs-4 col-sm-push-0 col-sm-4 col-md-4">
                            <form class="form-inline">
                                <div class="form-group">
                                    <div class="row mount">
                                        <div>
                                            <button v-on:click.prevent="!product.amount ? 0 : product.amount--">
                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                        <div>
                                            <input class="form-control" type="number" min="0" v-model="product.amount">
                                        </div>
                                        <div>
                                            <button v-on:click.prevent="product.amount++">
                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <!-- /.form-group -->
                                <!-- /.checkbox -->
                            </form>
                        </div>
                        <!-- /.col -->
                    </div>
                    <!-- /.row -->
                </div>
                <!-- /.extras-item -->
            </div>
            <!-- /.extras -->
        </div>
        <!-- /.box-inner -->
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { API } from '../api/axios'
import Datepicker from 'vuejs-datepicker'
import { de, en, es, fr, nl } from 'vuejs-datepicker/dist/locale'
import moment from 'moment'


export default {
  name: 'RecreationCheckoutCart',
  components: {Datepicker},
  props: {
    campsiteId: {
      type: String,
    },
    model: {
      type: Object,
    },
  },
  data () {
    return {
      importedLanguages: {
        // @TODO: Hard-coded languages!
        en, es, fr, de, nl,
      },
    }
  },
  computed: {
    ...mapGetters(['language']),
    formattedValidFrom () {
      return moment(this.model.validFrom).format('YYYY-MM-DD')
    }
  },
  methods: {
    dateChanged () {
      this.loadProductInfo()
    },
    callValidation () {
      return this.$validator.validate()
    },
    loadProductInfo () {
      // API.get(`/campsites/${this.campsiteId}?languageid=${this.language}`)
      API.get(`/campsites/${this.campsiteId}/products/${this.formattedValidFrom}`)
        .then(response => {
          let data = response.data
          for (let i = 0; i < data.length; i++) {
            let cartItem = this.model.productinfo.find(p => p.id === data[i].id)
            if (cartItem === undefined) {
              data[i].amount = 0
            } else {
              data[i].amount = cartItem.amount
            }
          }
          this.model.productinfo = data
        })
    },
  },
  created () {
    this.loadProductInfo()
  }
}
</script>

<style scoped>
button {
    height: 100%;
}

.row.mount {
    margin: 0;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type=number] {
    -moz-appearance:textfield; /* Firefox */
}
</style>



// WEBPACK FOOTER //
// src/components/RecreationCheckoutCart.vue